<div class="reset-container">
  <button
    mat-icon-button
    type="button"
    class="theme-toggle"
    [attr.aria-label]="(isDarkMode$ | async) ? 'Enable light mode' : 'Enable dark mode'"
    (click)="toggleTheme()">
    <mat-icon>{{ (isDarkMode$ | async) ? 'light_mode' : 'dark_mode' }}</mat-icon>
  </button>
  <mat-card class="reset-card">
    <mat-card-header>
      <mat-card-title>The Big Data Showroom (TBDS)</mat-card-title>
      <mat-card-subtitle>Set your password</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <div *ngIf="verifying" class="status-row">
        <mat-spinner diameter="22"></mat-spinner>
        <span>Verifying your link…</span>
      </div>

      <div *ngIf="!verifying && invalidOrExpired" class="error-box">
        <h3>Link expired</h3>
        <p>This password link has expired, was already used, or is invalid.</p>
        <p>If you need a new link, use the forgot-password flow or ask an admin to send a reset link.</p>
        <button mat-raised-button color="primary" (click)="goToLogin()">Back to login</button>
      </div>

      <div *ngIf="!verifying && !invalidOrExpired && passwordSetSuccess" class="success-box">
        <h3>Your password has successfully been set</h3>
        <p>You can now log in with your email address and new password.</p>
        <button mat-raised-button color="primary" class="full-width" (click)="goToLogin()">Go to login</button>
      </div>

      <form
        *ngIf="!verifying && !invalidOrExpired && !passwordSetSuccess"
        [formGroup]="form"
        (ngSubmit)="onSubmit()"
        autocomplete="on">
        <input
          type="email"
          name="username"
          autocomplete="username"
          [value]="form.get('email')?.value || ''"
          readonly
          tabindex="-1"
          aria-hidden="true"
          style="position: absolute; left: -10000px; width: 1px; height: 1px; opacity: 0; pointer-events: none;">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input
            matInput
            type="email"
            formControlName="email"
            name="email"
            autocomplete="username"
            readonly>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>New password</mat-label>
          <input
            matInput
            type="password"
            formControlName="password"
            name="new-password"
            autocomplete="new-password"
            required>
          <mat-hint>Use 8+ chars with uppercase, lowercase, and a special character.</mat-hint>
          <mat-error *ngIf="form.get('password')?.hasError('required')">Password is required</mat-error>
          <mat-error *ngIf="form.get('password')?.hasError('pattern')">
            Password must include uppercase, lowercase, and a special character.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Confirm password</mat-label>
          <input
            matInput
            type="password"
            formControlName="confirmPassword"
            name="confirm-password"
            autocomplete="new-password"
            required>
          <mat-error *ngIf="form.get('confirmPassword')?.hasError('required')">Confirm your password</mat-error>
          <mat-error *ngIf="passwordMismatch">Passwords do not match</mat-error>
        </mat-form-field>

        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="full-width"
          [disabled]="form.invalid || loading">
          <mat-spinner diameter="20" *ngIf="loading" style="display: inline-block; margin-right: 8px;"></mat-spinner>
          {{ loading ? 'Saving…' : 'Set password' }}
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>

